/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonChangeOfobject,
    JsonChangeOfobjectFromJSON,
    JsonChangeOfobjectFromJSONTyped,
    JsonChangeOfobjectToJSON,
} from './JsonChangeOfobject';

/**
 * 
 * @export
 * @interface JsonStratComment
 */
export interface JsonStratComment {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonStratComment
     */
    allowedActions?: Array<JsonStratCommentAllowedActionsEnum>;
    /**
     * 
     * @type {Array<JsonChangeOfobject>}
     * @memberof JsonStratComment
     */
    changes?: Array<JsonChangeOfobject>;
    /**
     * 
     * @type {number}
     * @memberof JsonStratComment
     */
    commentId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonStratComment
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonStratComment
     */
    createdBy?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonStratComment
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonStratComment
     */
    onepagerId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonStratComment
     */
    status?: JsonStratCommentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonStratComment
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonStratComment
     */
    updatedBy?: number;
}

/**
* @export
* @enum {string}
*/
export enum JsonStratCommentAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}/**
* @export
* @enum {string}
*/
export enum JsonStratCommentStatusEnum {
    Deleted = 'DELETED',
    Active = 'ACTIVE'
}

export function JsonStratCommentFromJSON(json: any): JsonStratComment {
    return JsonStratCommentFromJSONTyped(json, false);
}

export function JsonStratCommentFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonStratComment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'changes': !exists(json, 'changes') ? undefined : ((json['changes'] as Array<any>).map(JsonChangeOfobjectFromJSON)),
        'commentId': !exists(json, 'commentId') ? undefined : json['commentId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'onepagerId': !exists(json, 'onepagerId') ? undefined : json['onepagerId'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
    };
}

export function JsonStratCommentToJSON(value?: JsonStratComment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'changes': value.changes === undefined ? undefined : ((value.changes as Array<any>).map(JsonChangeOfobjectToJSON)),
        'commentId': value.commentId,
        'createdAt': value.createdAt,
        'createdBy': value.createdBy,
        'description': value.description,
        'onepagerId': value.onepagerId,
        'status': value.status,
        'updatedAt': value.updatedAt,
        'updatedBy': value.updatedBy,
    };
}

